import { useTranslate } from '@refinedev/core';
import { useSelect } from '@refinedev/antd';
import { Select, theme } from 'antd';
import { FilterOutlined } from '@ant-design/icons';

interface PublisherContextSwitcherProps {
  value: number | null;
  onChange: (publisherId: number | null) => void;
}

/** Page-level publisher scope; `null` means every publisher. */
export const PublisherContextSwitcher = ({
  value,
  onChange,
}: PublisherContextSwitcherProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const { selectProps } = useSelect({
    resource: 'content_catalog.publishers',
    optionLabel: 'name',
    optionValue: 'id',
    // Keep the chosen publisher resolvable after a reload with ?publisher_id=.
    defaultValue: value ?? undefined,
    onSearch: (q) => [{ field: 'q', operator: 'contains', value: q }],
  });

  return (
    <Select<number | 'all'>
      onSearch={selectProps.onSearch}
      loading={selectProps.loading}
      value={value ?? 'all'}
      onChange={(v) => onChange(v === 'all' ? null : Number(v))}
      options={[
        {
          value: 'all',
          label: t(
            'content_catalog.distribution_periods.context.all_publishers'
          ),
        },
        ...(selectProps.options ?? []),
      ]}
      showSearch
      filterOption={false}
      variant="filled"
      prefix={<FilterOutlined style={{ color: token.colorPrimary }} />}
      popupMatchSelectWidth={false}
      style={{ minWidth: 220, fontWeight: token.fontWeightStrong }}
      aria-label={t(
        'content_catalog.distribution_periods.fields.publisher_name'
      )}
    />
  );
};
